module.exports = __webpack_public_path__ + "images/emoji/hocho.21d3995c6e2b41b4c8e8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hocho.png
// module id = CkAa
// module chunks = 13